import { ApplicationRef, createComponent, EnvironmentInjector, Injectable, Type } from '@angular/core';
import { ModalContainerComponent } from '@shared/components/modal-container/modal-container.component';
import { ModalSize } from '@shared/types/modal-size.type';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) {}

  public open(component: Type<any>, config?: {
    data?: any;
    title?: string;
    showActions?: boolean;
    size?: ModalSize;
    onConfirm?: () => void;
  }) {

    const componentRef = createComponent(ModalContainerComponent, {
      environmentInjector: this.injector
    });

    componentRef.instance.component = component;
    componentRef.instance.data = config?.data;
    componentRef.instance.title = config?.title || '';
    componentRef.instance.showActions = config?.showActions || false;
    componentRef.instance.size = config?.size ?? 'lg';

    componentRef.instance.close = () => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    };

    componentRef.instance.confirm = config?.onConfirm;

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as any).rootNodes[0];
    document.body.appendChild(domElem);
  }
}
